import { Trash2 } from "lucide-react";
import { fileUrl } from "../lib/api";

function formatTime(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

// URL regex — http(s), www., and bare domains with optional path
const URL_REGEX = /\b((?:https?:\/\/|www\.)[^\s<>"']+|[a-z0-9-]+\.(?:de|com|net|org|eu|at|ch|io|app|info|co)(?:\/[^\s<>"']*)?)/gi;

function renderWithLinks(text, isOwn) {
  if (!text) return null;
  const parts = [];
  let lastIdx = 0;
  let m;
  URL_REGEX.lastIndex = 0;
  while ((m = URL_REGEX.exec(text)) !== null) {
    if (m.index > lastIdx) parts.push(text.slice(lastIdx, m.index));
    const raw = m[0];
    const href = raw.startsWith("http") ? raw : `https://${raw}`;
    parts.push(
      <a
        key={`l-${m.index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`underline break-all ${isOwn ? "text-slate-900 hover:text-blue-100" : "text-[#4DBFFF] hover:text-slate-900"}`}
      >
        {raw}
      </a>
    );
    lastIdx = m.index + raw.length;
  }
  if (lastIdx < text.length) parts.push(text.slice(lastIdx));
  return parts;
}

export default function MessageBubble({ msg, isOwn, canDelete = false, onDelete }) {
  return (
    <div
      className={`msg-in group flex w-full mb-3 ${isOwn ? "justify-end" : "justify-start"}`}
      data-testid={`message-${msg.id}`}
    >
      {!isOwn && (
        <img
          src={msg.user_avatar ? fileUrl(msg.user_avatar) : "https://images.unsplash.com/photo-1718434067642-49d79ab4d15f?crop=entropy&cs=srgb&fm=jpg&q=85&w=80"}
          alt={msg.user_name}
          className="w-9 h-9 rounded-full object-cover border border-slate-200 mr-2 shrink-0"
        />
      )}
      <div className={`max-w-[78%] md:max-w-[60%] relative`}>
        {!isOwn && (
          <div className="text-[11px] text-slate-600 mb-1 ml-1 font-semibold flex items-center gap-1.5 flex-wrap">
            <span>{msg.user_name}</span>
            {msg.user_is_support && (
              <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 font-bold">
                TSU Support
              </span>
            )}
          </div>
        )}
        <div
          className={`px-4 py-3 rounded-[20px] text-[15px] leading-relaxed break-words whitespace-pre-wrap shadow-sm ${
            isOwn
              ? "bg-[#1D5BFF] text-white rounded-tr-md"
              : "bg-[#EEF3FA] text-slate-900 rounded-tl-md border border-slate-200/60"
          }`}
        >
          {msg.image_url && (
            <img
              src={fileUrl(msg.image_url)}
              alt="Anhang"
              className="rounded-lg mb-2 max-w-full max-h-72 object-contain border border-slate-200"
            />
          )}
          {renderWithLinks(msg.content, isOwn)}
        </div>
        <div className={`text-[10px] text-slate-500 mt-1 flex items-center gap-2 ${isOwn ? "justify-end mr-1" : "ml-1"}`}>
          <span>{formatTime(msg.created_at)}</span>
          {canDelete && (
            <button
              onClick={() => onDelete && onDelete(msg)}
              data-testid={`delete-message-${msg.id}`}
              className="opacity-0 group-hover:opacity-100 transition-opacity text-red-400 hover:text-red-300"
              title="Nachricht löschen"
            >
              <Trash2 className="w-3 h-3" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
